import * as S from "../Style/Page/General.style.js";
const PageTitle = (props) => {
  return (
    <S.PageTitle>
      <span></span>
      <div className="title">
        <div class="kor">{props.titleko}</div>
        <div class="eng">{props.titleeng}</div>
      </div>
      {props.link && <a href={props.link}>@ 바로가기</a>}
    </S.PageTitle>
  );
};

export default PageTitle;
